import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';
import { EngineerService } from '../../../services/engineer.service';

@Component({
  selector: 'app-engineers',
  templateUrl: './engineers.component.html',
  styleUrls: ['./engineers.component.scss']
})
export class EngineerComponent implements OnInit {
  loading: boolean = false;
  rows = [];

  filter: any = {
    company_Id: undefined,
    location_Id: undefined,
    name: '',
    email: ''
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private engineerService: EngineerService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    if (this.authService.currentUser.value.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['reports/rote']);
    }
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }
  }

  ngOnInit(): void {
    this.getCounts();
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.engineerService.getTable(this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email).then((rows) => {
      this.rows = rows;
      this.loading = false;
    });
  }
  licenseCount;
  activeUsers;
  totalUsers;
  expiredUsers;

  getCounts() {
    this.engineerService.getEngineerCounts().then((data) => {
      this.licenseCount = data.licenseCount;
      this.activeUsers = data.activeUsers;
      this.totalUsers = data.totalUsers;
      this.expiredUsers = data.licenseCount - data.activeUsers;
      //console.log("engineer counts");
      //console.log(data);
    });
  }
  rebind() {
    this.loadTable();
  }
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable();
  }

  setPage(pageInfo) {

    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }

  add() {
    this.router.navigate(['engineers/manage']);
  }


}
